import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

type Align = 'end' | 'start' | 'between';

interface C1ActionsProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  align?: Align;
  /** Drop the auto bottom-pinning margin (for non-card layouts). */
  flush?: boolean;
}

/** Action row — pins to the bottom of a C1 card column by default. */
export function C1Actions({
  children,
  align = 'end',
  flush = false,
  className,
  ...props
}: C1ActionsProps) {
  return (
    <div
      className={cx(
        'c1-actions',
        align === 'start' && 'c1-actions--start',
        align === 'between' && 'c1-actions--between',
        flush && 'c1-actions--flush',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
